import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import PackageDetail from './components/PackageDetail';
import AvailabilityManagement from './components/AvailabilityManagement'; // PRIDANÝ IMPORT
import { isAuthenticated, clearAuth } from './utils/auth';
import './App.css';

function App() {
  const [authChecked, setAuthChecked] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      console.log('Checking authentication status...');

      const isAuth = isAuthenticated();
      console.log('Authentication result:', isAuth);

      // Ak token nie je platný, vymažeme všetky autentifikačné údaje
      if (!isAuth) {
        console.log('Token is invalid, clearing auth data');
        clearAuth();
      }

      setAuthenticated(isAuth);
      setAuthChecked(true);
    };

    checkAuth();
  }, []);

  const handleLoginSuccess = () => {
    console.log('Login success callback called');
    setAuthenticated(true);
  };

  const handleLogout = () => {
    console.log('Logout callback called');
    clearAuth();
    setAuthenticated(false);
  };

  // Kým kontrolujeme autentifikáciu, zobrazíme loading
  if (!authChecked) {
    return (
      <div className="loading-container">
        <div className="loading">Kontrolujem prihlásenie...</div>
      </div>
    );
  }

  console.log('App rendered, authenticated:', authenticated);

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route
            path="/login"
            element={
              !authenticated ?
                <LoginPage onLoginSuccess={handleLoginSuccess} /> :
                <Navigate to="/dashboard" replace />
            }
          />
          <Route
            path="/dashboard"
            element={
              authenticated ?
                <Dashboard onLogout={handleLogout} /> :
                <Navigate to="/login" replace />
            }
          />
          <Route
            path="/package/:packageId"
            element={
              authenticated ?
                <PackageDetail onLogout={handleLogout} /> :
                <Navigate to="/login" replace />
            }
          />
          {/* PRIDANÁ NOVÁ ROUTA PRE SPRÁVU DOSTUPNOSTI */}
          <Route
            path="/availability"
            element={
              authenticated ?
                <AvailabilityManagement onLogout={handleLogout} /> :
                <Navigate to="/login" replace />
            }
          />
          <Route
            path="/"
            element={
              <Navigate to={authenticated ? "/dashboard" : "/login"} replace />
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;